import { Box, Modal, Typography } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import type { FunctionComponent } from "react";
import { useStaticDataAtomValue } from "../staticDataAtom";

interface Props {
    visible: boolean;
    onClose: () => void;
}

export const ContentPolicyModal: FunctionComponent<Props> = ({ visible, onClose }) => {
    const {
        cmsData: {
            photo: {
                agodaContentPolicy,
                thisPolicyAppliesToAllContent,
                youMustNotUploadInformation,
                defamesAnyPerson,
                isIncorrectOrMisleading,
                promotesDiscriminationOrBias,
                encouragesViolence,
                violatesAnApplicableLaw,
                linksToAnyOfTheAbove,
                weMayDeleteAnyInformation,
            },
        },
    } = useStaticDataAtomValue();

    return (
        <Modal
            visible={visible}
            title={agodaContentPolicy}
            actions={[
                { label: "Close", variant: "label", hierarchy: "primary", actionType: "button", onClick: onClose },
            ]}
            onClose={onClose}
        >
            <VStack gap="16">
                <Typography variant="body-s">{thisPolicyAppliesToAllContent}</Typography>
                <Typography variant="body-s">{youMustNotUploadInformation}</Typography>
                <Box as="ul" m="0" ps="24">
                    <li>
                        <Typography variant="body-s">{defamesAnyPerson}</Typography>
                    </li>
                    <li>
                        <Typography variant="body-s">{isIncorrectOrMisleading}</Typography>
                    </li>
                    <li>
                        <Typography variant="body-s">{promotesDiscriminationOrBias}</Typography>
                    </li>
                    <li>
                        <Typography variant="body-s">{encouragesViolence}</Typography>
                    </li>
                    <li>
                        <Typography variant="body-s">{violatesAnApplicableLaw}</Typography>
                    </li>
                    <li>
                        <Typography variant="body-s">{linksToAnyOfTheAbove}</Typography>
                    </li>
                </Box>
                <Typography variant="body-s">{weMayDeleteAnyInformation}</Typography>
            </VStack>
        </Modal>
    );
};
